export default __webpack_public_path__ + "static/media/GreenHouse1.af014270.webp";